import * as headerBlock from '../header/';

const alert = require('vue-strap').alert;

export default  {
  name: 'roles',
  components: { headerBlock, alert },
  props: [
    'onLogout',
    'access_token',
    'authUser',
  ],
  mounted() {

  },
  data() {
    return {
      formData: {
        manager_role_display_name: '',
        shift_leader_role_display_name: '',
        basic_role_display_name: '',
      },
      breadCrumbItems: [
        {
          text: 'Home',
          to: `${process.env.START_URL}/`,
        }, {
          text: 'Roles',
          active: true,
        },
      ],
      alertError: {
        text: 'An errors occurred.',
        title: 'Error!',
        visible: false,
      },
      alertSuccess: {
        text: 'Roles were saved',
        title: 'Success!',
        visible: false,
      },
    };
  },
  methods: {
    submit() {
      let url = 'companies/';
      if (this.$route.params.companyId) {
        url = `${url}${this.$route.params.companyId}/`;
      } else {
        url = `${url}${this.authUser.company.id}/`;
      }
      this.$http.patch(url, this.formData,
      {
        method: 'PATCH',
        headers: {
          Authorization: `Token ${this.access_token}`,
        },
        // emulateJSON: true,
      })
      .then((response) => {
        if (response.status !== 200) {
          console.log(response);
          return;
        }
        this.updateCompany();
      })
      .catch((response) => {
        if (response.status === 401) {
          this.onLogout();
        }
      });;
    },
    updateCompany(update = true) {
      let url = 'companies/';
      if (this.$route.params.companyId) {
        url = `${url}${this.$route.params.companyId}/`;
      } else {
        url = `${url}${this.authUser.company.id}/`;
      }
      this.$http.get(url,
        {
          method: 'get',
          headers: {
            Authorization: `Token ${this.access_token}`,
          },
          // emulateJSON: true,
        })
        .then((response) => {
          if (response.status !== 200) {
            console.log(response);
            return response;
          }
          this.alertSuccess.visible = update;
          if (this.authUser && !this.$route.params.companyId) {
            this.authUser.company = response.body;
            localStorage.setItem('authUser', JSON.stringify(this.authUser));
          }
          if (response.body.manager_role_display_name) {
            this.formData.manager_role_display_name = response.body.manager_role_display_name;
          }
          if (response.body.shift_leader_role_display_name) {
            this.formData.shift_leader_role_display_name = response.body.shift_leader_role_display_name;
          }
          if (response.body.basic_role_display_name) {
            this.formData.basic_role_display_name = response.body.basic_role_display_name;
          }
        })
        .catch((response) => {
          if (response.status === 401) {
            this.onLogout();
          }
          this.alertError.visible = true;
        });
    },
  },
  created() {
    if (this.authUser && this.authUser.company) {
      this.formData.basic_role_display_name = this.authUser.company.basic_role_display_name;
      this.formData.shift_leader_role_display_name =
        this.authUser.company.shift_leader_role_display_name;
      this.formData.manager_role_display_name = this.authUser.company.manager_role_display_name;
    }
    this.updateCompany(false);
  },
  computed: {

  }
}



// WEBPACK FOOTER //
// ./src/components/roles/roles.component.js